export enum VIDEO_TUTORIAL {
  TEACHER_DASHBOARD = 1,
  LESSON_PLAN = 16,
  ADMIN_DASHBOARD = 7,
  EDIT_PACING_PLAN = 18,
  AUTO_CLASSROOM = 12,
  MANUAL_CLASSROOM = 13,
  COPY_CLASSROOM = 14,
  LESSON_PLAN_CREATION = 15,
  SCHOOL_INSTRUCTIONAL_PERIOD = 4,
}
